const EventEmitter = require('events');

class Stream extends EventEmitter {}

module.exports = { Stream };
